import styled from 'styled-components'

export const DatePickerWrapper = styled.div`
  width: 100%;
  background-color: ${({ disabled, theme }) => (disabled ? theme.colors.backgroundLite : 'transparent')};
`

export const FormGroupWrapper = styled.div`
  position: relative;
  min-height: 48px;
`

export const DateInput = styled.input`
  display: none;
`

export const SelectOption = styled.option`
  color: ${({ theme }) => theme.colors.primary};
`

export const DateInputLabel = styled.div`
  cursor: pointer;
  transition: 0.4s;
  color: ${({ theme }) => theme.colors.primary};

  position: relative;
  // TODO: Use theme functions
  &:after {
    content: '';

    position: absolute;
    top: 42%;
    right: 15px;

    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;

    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    color: ${({ theme }) => theme.colors.primary};
  }

  min-height: 48px;
  height: fit-content;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};

  &:hover {
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.1);
  }
`

export const SelectInputOptionsContainer = styled.div`
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 300px;
  overflow-y: auto;

  padding: 10px;
  width: 100%;

  font-size: 14px;
  border-radius: 10px;
  font-weight: 400;
  background-color: ${({ theme }) => theme.colors.background};
  border: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};
  user-select: none;
  z-index: 2;
`

export const SelectInputOptions = styled.div`
  display: flex;
  padding: 10px;
  color: ${({ theme }) => theme.colors.primary};

  cursor: pointer;
  transition: 0.4s;

  border: ${({ theme }) => `1px solid ${theme.colors.backgroundLite}`};
  border-radius: 10px;

  &:hover {
    background: ${({ theme }) => theme.colors.borderColor};
  }
`
